module.exports = __webpack_public_path__ + "app/themes/vwfs/sme-price-list-assets/img/double-cab-tipper-active.87d45094.svg";